import useI18n from '@i18n';
import routes from '@config/routes.json';

import BaseSemanticLink from '@base/BaseSemanticLink';
import BaseContainer from '@base/BaseContainer';

import WithdrawalMethods from './WithdrawalMethods';
import { IFooterLinkItem } from './interfaces';

const menuLinks: IFooterLinkItem[] = [
    {
        key: 'Rules',
        id: 'FooterRulesLink',
        href: routes.rules,
    },
    {
        key: 'Privacy',
        id: 'FooterPrivacyLink',
        href: routes.privacy,
    },
];

const Footer: React.FC<{ isAuth: boolean | null }> = ({ isAuth }) => {
    const { t } = useI18n();

    return (
        <footer className="py-6 bg-white xs:py-8">
            <BaseContainer>
                <div className="flex flex-col items-center gap-8 xs:flex-row xs:flex-wrap xs:items-center xs:justify-between">
                    <div className="flex flex-wrap items-center gap-8 xs:w-full md:w-auto">
                        {menuLinks.map((link: IFooterLinkItem) => {
                            if (typeof link.isVisible === 'boolean' && !link.isVisible) {
                                return null;
                            }
                            if (link.isAuth && link.isAuth !== isAuth) {
                                return null;
                            }

                            return (
                                <span key={link.key}>
                                    <BaseSemanticLink
                                        className="text-[14px] leading-[21px] text-blueGray-600"
                                        id={link.id}
                                        to={link.href}
                                    >
                                        {t(link.key)}
                                    </BaseSemanticLink>
                                </span>
                            );
                        })}
                    </div>

                    <p className="order-2 md:order-1 whitespace-nowrap text-[12px] leading-[18px] text-blueGray-300">
                        2013-{new Date().getFullYear()} ePN Development Team
                    </p>

                    <div className="order-1 md:order-2">
                        <WithdrawalMethods />
                    </div>
                </div>
            </BaseContainer>
        </footer>
    );
};

export default Footer;
